/**
 *
 * leave request Page
 *
 */
import Select from "react-select"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
// import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  // Table,
  // Spinner,
  Input,
  Badge,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { useSelector, useDispatch } from "react-redux"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// dispatch actions
import * as alterListAction from "../../store/YWx0ZXJRdW90ZUxpc3Q/actions"
import { isEmpty } from "lodash"
//Import Styles
import "./styles.scss"
import ButtonSpinner from "../../components/ButtonSpinner"
// style for autocomplete
// import { styles } from "../../pages/ClientDetails/Input-Select/select"
//date format
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
// import { toast } from "react-toastify"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"

const AlterQuoteList = (props) => {
  const title = "Alter Quote List"

  const { dispatch, searchBarStyle } = props
  const specificDispatch = useDispatch()

  const { SearchBar } = Search

  useEffect(() => {
    dispatch(alterListAction.loadRecordsMetaData())
    dispatch(alterListAction.loadAlterQuoteList())
  }, [])

  const update = useSelector((specificstate) => specificstate)

  console.log("update is", update)

  const alterQuoteUpdate = useSelector(
    (specificstate) => specificstate.alterQuoteList
  )
  const { alterListMetaData = {}, alter_quote_list = [] } = alterQuoteUpdate
  // Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  console.log(user, "user details from session")
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  console.log(alter_quote_list.branchName)
  console.log("alterQuoteUpdate is", alterQuoteUpdate)
  const [btnLoader, setBtnLoader] = useState(false)
  const [alterData, setAlterData] = useState({
    company: [],
    branch: [],
    department: [],
    employeeCode: [],
    fromDate: "",
    toDate: "",
  })
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [servicelist, setServicelist] = useState([])
  const [priorityCode, setPriorityCode] = useState([])
  const [salesUrge, setSalesUrge] = useState([])
  const [leadNo, setLeadNo] = useState("")

  //dropdown options api
  const branchOptions =
    !isEmpty(alterListMetaData) &&
    alterListMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  // const employeeOptions = createOptions(employeeList)
  //checking
  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const service =
    !isEmpty(servicelist) && servicelist.map((service) => service.value)
  const priority =
    !isEmpty(priorityCode) && priorityCode.map((priority) => priority.value)
  const startDate = alterData.fromDate
  const endDate = alterData.toDate

  console.log(
    company,
    branch,
    service,
    priority,
    startDate,
    endDate,
    "dropdown outputs"
  )

  const handleChange = async (e) => {
    setAlterData({ ...alterData, [e.target.name]: e.target.value })
  }
  const handleFilter = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchService = servicelist && servicelist ? service : ""
    var searchPriority = priorityCode && priorityCode ? priority : ""

    var searchLeadNo = leadNo && leadNo ? leadNo : ""
    var searchFromDate =
      alterData && alterData.fromDate
        ? moment(alterData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      alterData && alterData.toDate
        ? moment(alterData.toDate).format("YYYY-MM-DD")
        : ""
    var searchSalesUrge = salesUrge && salesUrge.value ? salesUrge.value : ""

    var searchvalue = {}
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchService) {
      searchvalue.serviceId = searchService
    }
    if (searchPriority) {
      searchvalue.priorityId = searchPriority
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }
    if (searchSalesUrge) {
      searchvalue.salesUrge = searchSalesUrge
    }

    console.log("searchCompany", searchvalue)
    specificDispatch(alterListAction.loadAlterQuoteList(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  console.log()
  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setServicelist([])
    setPriorityCode([])
    setAlterData({
      fromDate: "",
      toDate: "",
    })
    setLeadNo("")
    setSalesUrge([])
  }
  // const [approvedData, setApprovedData] = useState("")

  let slNo = 0
  const alterDataTable = !isEmpty(alter_quote_list)
    ? alter_quote_list.map((alterData, index) => {
        slNo = slNo + 1

        var salesDate = !isEmpty(alterData.salesDate)
          ? moment(alterData.salesDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(`${dateFormate} hh:mm A`)
          : []
        return {
          _id: alterData._id,
          sNo: slNo,
          name: alterData.clientName,
          quotationStatus: alterData.quotationStatus,
          alterQuoteStatus: (
            <Badge className="font-size-12 badge rounded-pill bg-primary badge-soft-info">
              {alterData.alterStatusName}
            </Badge>
          ),
          alterRemarks: alterData.alterRemarks,
          processStatus: alterData.processStatus,
          processStatusName: alterData.processStatusName,
          action: (
            <Button
              type="submit"
              style={{ fontSize: "10px" }}
              className="btn btn-success buttons"
            >
              <i className="fas fa-pen icon-btn"></i>
            </Button>
          ),
          attachments: alterData.attachments,
          leadNo: (
            <span style={{ textTransform: "uppercase", color: "#e40d8c" }}>
              {alterData.leadNo}
            </span>
          ),
          branchId: alterData.branchId,
          clientNo: (
            <span style={{ textTransform: "uppercase", color: "#e40d8c" }}>
              {alterData.clientNo}
            </span>
          ),
          branchName: alterData.branchName,
          phoneNo: alterData.contact
            ? alterData.contact.primaryMobile.code +
              alterData.contact.primaryMobile.number
            : "",
          companyId: alterData.companyId,
          companyName: alterData.companyName,
          event: alterData.eventName,
          leadSourceName: alterData.leadSourceName,
          leadDate: alterData.leadDate
            ? moment(alterData.leadDate).format("DD-MM-YYYY hh:mm A")
            : [],
          leadServiceName: alterData.leadServiceName,
          priorityStatusName: alterData.priorityStatusName,
          salesEntry:
            alterData.processStatus === "PS9" ? (
              <Badge
                className={
                  "font-size-12 badge rounded-pill bg-success badge-soft-success"
                }
              >
                Completed
              </Badge>
            ) : (
              <Badge className="font-size-12 badge rounded-pill bg-danger badge-soft-danger">
                Pending
              </Badge>
            ),
          quotationNo: alterData.quotationNo,
          salesExecutive: alterData.leadAssign,
          saleDate: salesDate,
          coupleName:
            isEmpty(alterData.brideName) && isEmpty(alterData.groomName)
              ? ""
              : alterData.brideName + " & " + alterData.groomName,
          salesUrge: alterData.salesUrge,
          fromTime: alterData.fromTime,
          toTime: alterData.toTime,
          key: index,
        }
      })
    : []
  //pagination table data columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "alterQuoteStatus",
      text: "Alter Quote Status",
      sort: true,
      headerStyle: {
        minWidth: "170px",
      },
    },
    // {
    //   dataField: "processStatusName",
    //   text: "Quotation Status",
    //   sort: true,
    //   headerStyle: {
    //     minWidth: "160px",
    //   },
    // },
    {
      dataField: "salesEntry",
      text: "Sales Entry Status",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "alterRemarks",
      text: "Alter Quote Remarks",
      sort: true,
      headerStyle: {
        minWidth: "188px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "priorityStatusName",
      text: "Client Priority",
      sort: true,
      headerStyle: {
        minWidth: "138px",
      },
    },
    {
      dataField: "quotationNo",
      text: "Quotation No",
      sort: true,
      headerStyle: {
        minWidth: "138px",
      },
    },
    {
      dataField: "clientNo",
      text: "Client Code",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "name",
      text: "Client Name",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "coupleName",
      text: "Bride & Groom Name",
      sort: true,
      headerStyle: {
        minWidth: "185px",
      },
    },
    {
      dataField: "phoneNo",
      text: "Phone",
      sort: true,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "leadNo",
      text: "Lead Number",
      sort: true,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "leadSourceName",
      text: "Source",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "salesExecutive",
      text: "Sales Executive",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "saleDate",
      text: "Sales Date",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "event",
      text: "Event Name",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "salesUrge",
      text: "Sales Urge",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
  ]
  console.log(columns)

  const salesUrgeOptions = [
    {
      label: "hot",
      value: "hot",
    },
    {
      label: "warm",
      value: "warm",
    },
    {
      label: "cold",
      value: "cold",
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Sales"} breadcrumbItem={title} />

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            alterListMetaData
                              ? alterListMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Service"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="service"
                          value={servicelist}
                          isMulti
                          onChange={(e) => setServicelist(e)}
                          options={
                            alterListMetaData
                              ? alterListMetaData.serviceOptions
                              : []
                          }
                          placeholder="Select Service"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Priority"}</Label>
                        </div>
                        <Select
                          name="priority"
                          value={priorityCode}
                          onChange={(e) => setPriorityCode(e)}
                          isMulti
                          options={
                            alterListMetaData
                              ? alterListMetaData.priorityOptions
                              : []
                          }
                          placeholder="Select Priority"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Sales Urge"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="salesUrge"
                          value={salesUrge}
                          onChange={(e) => setSalesUrge(e)}
                          options={salesUrgeOptions}
                          placeholder="Select Sales Urge"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={alterData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"To Date"}>
                            {"To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={alterData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label">{"Lead No"}</Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead No"
                          name="leadNo"
                          value={leadNo}
                          onChange={(e) => setLeadNo(e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => handleFilter()}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>

                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <ToolkitProvider
                    keyField="_id"
                    data={alterDataTable}
                    columns={columns}
                    search
                  >
                    {(props) => (
                      <div>
                        <Col md="12" xl="12" lg="12" sm="12" xs="12">
                          <Row className="d-flex flex-column">
                            <Col className="mb-3 search-bar">
                              <div className="search-box me-2 mb-2 d-inline-block">
                                <div
                                  className="position-relative mt-3"
                                  style={searchBarStyle || null}
                                >
                                  <SearchBar {...props.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col>
                              <BootstrapTable
                                {...props.baseProps}
                                responsive
                                pagination={paginationFactory()}
                                striped={true}
                                bordered={true}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </div>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AlterQuoteList.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AlterQuoteList)
)
